import { createContext } from '@shared/utils/createContext';
import type { SwipeActionContextValue } from './SwipeAction.types';

export const [SwipeActionProvider, useSwipeActionContext] = createContext<SwipeActionContextValue>({
  name: 'SwipeActionProvider',
  strict: true,
});
